module.exports = __webpack_public_path__ + "static/avatar-25ea8c10525333fa48db6cf8e2e2ee08.png";